import { useDispatch } from "react-redux";
import api from "../../../_metronic/helpers/api";
import { showAlert } from "../../redux/reducers/alertSlice";

function useUtils() {
  const dispatch = useDispatch();

  const fetchCategories = async (limit=10, offset=0) => {
    try {
      const response = await api.get(`/category`, {
        params: {
          limit,
          offset,
        },
      });
      if (response.data.status) {
      return response.data.data;
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error.response.data.message || 'Network Error',
          variant: "danger",
        })
      );
    }
  };

  const submitcategory = async (values,onClose, limit, offset) => {
    try {
      const response = await api.post(`/category`, values);
      if (response.data.status) {
        dispatch(
          showAlert({
            message: "Category added",
            variant: "success",
          })
        );
        onClose()
      return fetchCategories(limit, offset)
      } else {
        dispatch(
          showAlert({ message: response.data.message, variant: "danger" })
        );
      }
    } catch (error) {
      dispatch(
        showAlert({ message: error.response.data.message, variant: "danger" })
      );
    }
  };

  const deleteCategory=async(id, limit, offset)=>{
    try {
      const response = await api.delete(`/category/${id}`);
        if(response.data.status){
          dispatch(showAlert({message:`Category Deleted`, variant:'success', timeout:'2000'}))
             return fetchCategories(limit, offset)
        }
     } catch (error) {
        dispatch(showAlert({message:error?.response?.data?.message || 'Network Error', variant:'danger'}))
        return fetchCategories(limit, offset)
     }
  }

  const handleEdit = async (name, id, onHide, limit, offset) => {
    try {
      const response = await api.patch(`/category/${id}`, {name});
      if (response.data.status) {
        onHide()
        dispatch(
          showAlert({
            message: `Category Modified`,
            variant: "success",
            timeout: "2000",
          })
        )
       return fetchCategories(limit, offset)
      }
    } catch (error) {
        dispatch(
            showAlert({
              message:error?.response?.data?.message || 'Network Error',
              variant: "danger",
              timeout: "2000",
            })
          )
       }
  };

  const makeDefault = async (values, limit, offset) => {
    try {
      const response = await api.patch(`/category/${values?.id}`, {isDefault:true});
      if (response.data.status) {
        dispatch(
          showAlert({
            message: `${values?.name} is now the default category`,
            variant: "success",
            timeout: "2000",
          })
        )
       return fetchCategories(limit, offset)
      }
    } catch (error) {
        dispatch(
            showAlert({
              message:error?.response?.data?.message || 'Network Error',
              variant: "danger",
              timeout: "2000",
            })
          )
       }
  };

  return {
    fetchCategories,
    submitcategory,
    deleteCategory,
    handleEdit,
    makeDefault
  };
}

export default useUtils;
